/// <reference path="../../_ext/Bases/DialogBase.ts" />
namespace TabAurous.OMS {

    @Serenity.Decorators.registerClass()
    export class VendorDialog extends Serenity.EntityDialog<VendorRow, any> {
        protected getFormKey() { return VendorForm.formKey; }
        protected getIdProperty() { return VendorRow.idProperty; }
        protected getLocalTextPrefix() { return VendorRow.localTextPrefix; }
        protected getNameProperty() { return VendorRow.nameProperty; }
        protected getService() { return VendorService.baseUrl; }
        protected getInsertPermission() { return VendorRow.insertPermission; }
        protected getUpdatePermission() { return VendorRow.updatePermission; }
        protected getDeletePermission() { return VendorRow.deletePermission; }
        protected useViewMode() { return true; }
        //protected isViewMode() { return true; }
        name: any;

        protected form = new VendorForm(this.idPrefix);
        private loadedState: string;
        constructor() {
            super();
            //if (this.getSaveState()) {
            //    Serenity.EditorUtils.setReadOnly(this.form.State, true);
            //    Serenity.EditorUtils.setReadOnly(this.form.City, true);
            //}
            q.hideEditorLabel(this.form.AddressDetails);
            q.hideEditorLabel(this.form.ContactDetails);
            q.hideCategorylinks(this.element);
            DialogUtils.pendingChangesConfirmation(this.element, () => this.getSaveState() != this.loadedState);

            this.form.LbrFlag.changeSelect2(e => {
                if (this.form.LbrFlag.value == true) {
                    Serenity.EditorUtils.setReadOnly(this.form.LbrAddDisc, false);
                    Serenity.EditorUtils.setReadOnly(this.form.LbrAddMkp, false);
                    Serenity.EditorUtils.setReadOnly(this.form.LbrFromDate, false);
                    Serenity.EditorUtils.setReadOnly(this.form.LbrToDate, false);
                } else {
                    Serenity.EditorUtils.setReadOnly(this.form.LbrAddDisc, true);
                    Serenity.EditorUtils.setReadOnly(this.form.LbrAddMkp, true);
                    Serenity.EditorUtils.setReadOnly(this.form.LbrFromDate, true);
                    Serenity.EditorUtils.setReadOnly(this.form.LbrToDate, true);
                }
            });
            this.form.StnFlag.changeSelect2(e => {
                if (this.form.StnFlag.value == true) {
                    Serenity.EditorUtils.setReadOnly(this.form.StnAddDisc, false);
                    Serenity.EditorUtils.setReadOnly(this.form.StnAddMkp, false);
                    Serenity.EditorUtils.setReadOnly(this.form.StnFromDate, false);
                    Serenity.EditorUtils.setReadOnly(this.form.StnToDate, false);
                } else {
                    Serenity.EditorUtils.setReadOnly(this.form.StnAddDisc, true);
                    Serenity.EditorUtils.setReadOnly(this.form.StnAddMkp, true);
                    Serenity.EditorUtils.setReadOnly(this.form.StnFromDate, true);
                    Serenity.EditorUtils.setReadOnly(this.form.StnToDate, true);
                }
            });
            this.form.TaxRegType.changeSelect2(e => {
                if (this.form.TaxRegType.value == "289")
                    Serenity.EditorUtils.setRequired(this.form.GstVat, true);
                else
                    Serenity.EditorUtils.setRequired(this.form.GstVat, false);
            });

        }
        getSaveState() {
            try {
                return $.toJSON(this.getSaveEntity());
            }
            catch (e) {
                return null;
            }
        }


        loadResponse(data) {
            super.loadResponse(data);
            this.loadedState = this.getSaveState();
        } 
        protected validateBeforeSave() {
            super.validateBeforeSave();
            var defaultaddress = this.form.AddressDetails.getItems().filter(x => x.Default == true);
            if (defaultaddress.length == 0) {
                Q.alert('Atleast One Default Address Required');
                return false;
            }
            if (defaultaddress.length > 1) {
                Q.alert('Multiple Default Address not Allowed');
                return false;
            }
            return true;
        }
    }
}